class Menu {
  constructor() {
    this.settings = {
      hamburger: '.hamburger',
      headerNavigation: '.header__nav',
      overlay: '.overlay',
      header: '.header__content',
      mainNav: '#main-nav',
      navHeader: '.menu-mobile-header',
      close: '.close-icon',
      menuItem: '> .menu-item',
      searchBtn: '.button-search',
      searchContainer: '.input-container',
      inputSearch: '.input--search',
      closeSearch: '.button-close',
      newDropdown: '.new-dropdown'
    };
  }

  init() {
    const menuHamburger = $(this.settings.hamburger);
    const $this = this;
    const $nav = $(this.settings.headerNavigation);
    const $overlay = $(this.settings.overlay);
    const $header = $(this.settings.header);
    const $mainNav = $(this.settings.mainNav);
    const $menuItem = $($mainNav).find(this.settings.menuItem);
    const $closeBtn = $(this.settings.close);
    const $navHeader = $(this.settings.navHeader);
    const $searchBtn = $(this.settings.searchBtn);
    const $searchContainer = $(this.settings.searchContainer);
    const $inputSearch = $(this.settings.inputSearch);
    const $closeSearch = $(this.settings.closeSearch);
    const $newDropdown = $(this.settings.newDropdown);
    this.activeLink();
    this.constructor.blockClicks($mainNav);

    $searchBtn.on({
      click(e) {
        if (!$header.hasClass('search-form-active')) {
          e.preventDefault();
          $overlay.addClass('visible');
          $header.addClass('search-form-active');
          $searchContainer.addClass('active');
          $inputSearch.addClass('active');
        }
        if (!$inputSearch.val()) {
          e.preventDefault();
        }
      },
    });

    $closeSearch.on({
      click(e) {
        e.preventDefault();
        $overlay.removeClass('visible');
        $header.removeClass('search-form-active');
        $inputSearch.removeClass('active');
        $searchContainer.removeClass('active');
      },
    });

    menuHamburger.on({
      click(e) {
        e.preventDefault();
        $header.removeClass('search-form-active');
        $inputSearch.removeClass('active');
        $overlay.removeClass('visible');
        $this.toggleMenu(this);
        menuHamburger.toggleClass('is-active');
      },
    });

    $overlay.on({
      click(e) {
        e.preventDefault();
        $header.removeClass('search-form-active');
        $inputSearch.removeClass('active');
        $('body').removeClass('menu-open');
        $nav.removeClass('visible');
        $overlay.removeClass('visible');
        $navHeader.removeClass('visible');
        menuHamburger.removeClass('clicked');
        $header.removeClass('menu');
        $menuItem.find('.sub-menu').removeClass('clicked');
        $menuItem.find('.sub-menu').find('.menu-item').removeClass('clicked');
        menuHamburger.removeClass('is-active');
      },
    });

    $closeBtn.on({
      click(e) {
        e.preventDefault();
        $('body').removeClass('menu-open');
        $nav.removeClass('visible');
        $overlay.removeClass('visible');
        $navHeader.removeClass('visible');
        menuHamburger.removeClass('clicked');
        $header.removeClass('menu');
        $menuItem.find('.sub-menu').removeClass('clicked');
        $menuItem.find('.sub-menu').find('.menu-item').removeClass('clicked');
      },
    });

    $menuItem.mouseover(function mouseOver(e) {
      if (window.innerWidth < 1200) {
        return;
      }
      e.stopPropagation();
      const el = $(this).find('.sub-menu');
      $(this).addClass('active');
      el.addClass('dropdown');
      el.find('.menu-item').addClass('dropdown');
    });

    $menuItem.mouseleave(function mouseLeave(e) {
      if (window.innerWidth < 1200) {
        return;
      }
      e.stopPropagation();
      const el = $(this).find('.sub-menu');
      $(this).removeClass('active');
      el.removeClass('dropdown');
      el.find('.menu-item').removeClass('dropdown');
    });

    $menuItem.on('click', 'a', (e) => {
      const el = $(e.target.value);
      const $element = el.parent();

      el.addClass('clicked');
      $element.find('.sub-menu').find('.menu-item').toggleClass('clicked');
    });
    $newDropdown.each((i, menu) => {
      const list = $(menu).find('> ul');
      const $column = $("<div class='new-dropdown__column'></div>");
      $("<div class='new-dropdown__content'></div>").append(list.clone()).append($column).appendTo($(menu));
      const items = $(menu).find('.menu-item');
      items.mouseover((e) => {
        e.stopPropagation();
        const item = $(e.currentTarget);
        const $el = item.find('.sub-menu');
        items.removeClass('sub-active');
        item.addClass('sub-active');
        $column.empty();
        $column.append($el.clone());
      })
    })
  }

  static blockClicks(nav) {
    $(nav).find('a[href$="#"]').click((e) => {
      e.preventDefault();
      const parent = $(e.target).parent();
      const el = parent.find(window.innerWidth > 1200 ? '.sub-menu' : '> .sub-menu');
      if (el.hasClass('dropdown')) {
        parent.removeClass('active');
        el.removeClass('dropdown');
        el.find('.menu-item').removeClass('dropdown');
      } else {
        parent.addClass('active');
        el.addClass('dropdown');
        el.find('> .menu-item').addClass('dropdown');
      }
    });
  }

  activeLink() {
    const $menuItems = $(this.settings.headerNavigation).find('.menu-item');
    const url = window.location.href;
    $menuItems.map((index, item) => {
      const name = $(item).find('a').first().text()
        .toLowerCase();
      if (new RegExp(`/${name}/`).test(url.toLowerCase())) {
        $(item).addClass('current-menu-item');
      }
      return item;
    });
  }

  toggleMenu(element) {
    const $element = $(element);
    const $nav = $(this.settings.headerNavigation);
    const $overlay = $(this.settings.overlay);
    const $header = $(this.settings.header);
    const $navHeader = $(this.settings.navHeader);
    if ($element.hasClass('clicked')) {
      $nav.removeClass('visible');
      $nav.removeClass('visible');
      $element.removeClass('clicked');
      $header.removeClass('menu');
      $('body').removeClass('menu-open');
    } else {
      $('body').addClass('menu-open');
      $nav.addClass('visible');
      $navHeader.addClass('visible');
      $element.addClass('clicked');
      $overlay.addClass('visible');
      $header.addClass('menu');
    }
  }
}

export default Menu;
